import {useMutation, useQueryClient} from '@tanstack/react-query';

import {
  removeOnboardingGeoConfig,
  RemoveOnboardingGeoConfigParams,
} from '../api';
import {QUERY__ONBOARDING, QUERY__ONBOARDINGS} from '../queryKeys';

export const useRemoveOnboardingGeoConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: RemoveOnboardingGeoConfigParams) =>
      removeOnboardingGeoConfig(params),
    onSuccess: (_, {type}) => {
      void queryClient.invalidateQueries({queryKey: [QUERY__ONBOARDINGS]});
      void queryClient.invalidateQueries({
        queryKey: [QUERY__ONBOARDING, type],
      });
    },
  });
};
